import React, { useState, useEffect } from "react";
import { getMonthlyExp } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import { Select } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSiteRefrence } from "../../../api/endpoints/refrences";

const { Option } = Select;

const ExpRprt = () => {
  const { user, access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [itemsQueue, setItemsQueue] = useState([]);
  const [state, setState] = useState({
    parties: [],
    enteredOn: "",
    startingDate: "",
    partyId: "",
    partyName: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }

  const clearFields = () => {
    setState({
      parties: state.parties,
      // partyId: "",
      // partyName: "",
      // enteredOn: "",
      // startingDate: "",
    });
  };

  const [loading, setLoading] = useState(false);

const editHandler = async () => {
  if (!state.startingDate || !state.enteredOn)
    return message.error("Please select both start and end dates!");

  let data = {  
    startingDate: state.startingDate,
    enteredOn: state.enteredOn,
    siteId: Number(user.siteId),
    grpId: Number(user.grpId),
  };

  try {
    setLoading(true);
    const results = await getMonthlyExp(data, access_token); // API will CALL GetExpenseReportByMonth
console.log(results.data, "dtaaaa")


  if (results.success) {
  const payload = results.data[0] || []; // always an array of rows

  if (!Array.isArray(payload) || payload.length === 0) {
    return message.error("No Record Found in this date range");
  }

  setItemsQueue(payload);       // store the full array
  generatePDF(payload);         // send the full array to PDF
}


  } catch (err) {
    console.error(err);
    message.error("Something went wrong!");
  } finally {
    setLoading(false);
  }
};



  useEffect(() => {
    getName();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.getMonth() + 1; // months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };


const generatePDF = (data) => {
  if (!data || data.length === 0) {
    message.error("No data to generate report!");
    return;
  }

  const doc = new jsPDF("l", "mm", "a4"); // landscape

  // ===== Header =====
  const now = new Date();
  doc.setFontSize(8);
  doc.text(
    `Printed on: ${now.toLocaleDateString()} ${now.toLocaleTimeString()}`,
    260,
    20,
    { align: "right" }
  );
  doc.setFontSize(16);
  doc.text(siteName || "", 148, 11, { align: "center" });
  doc.setFontSize(12);
  doc.text(siteAddress || "", 148, 16, { align: "center" });
  doc.setFontSize(9);
  doc.text(
    `Expense Report From: ${formatDate(state.startingDate)} To ${formatDate(
      state.enteredOn
    )}`,
    148,
    20,
    { align: "center" }
  );


  const sample = data[0];
  const monthCols = Object.keys(sample).filter(
    (k) => k !== "generalLedgerCode" && k !== "ExpenseHead"
  );


  const headRow = ["Expense Head", ...monthCols];

      const bodyRows = data.map((row) => [
    row.ExpenseHead,
    ...monthCols.map((m) =>
      Number(row[m] || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    ),
  ]);

 
  // ===== Dynamic column widths =====
  const totalPageWidth = 297 - 10; // A4 landscape minus margins
  const fixedColsWidth = 50; // Expense Head column width
  const monthColsWidth = (totalPageWidth - fixedColsWidth) / monthCols.length;

  const colStyles = {
    0: { cellWidth: fixedColsWidth, halign: "left" }, // Expense Head
  };
  monthCols.forEach((_, i) => {
    colStyles[i + 1] = { cellWidth: monthColsWidth, halign: "right" };
  });

const grandTotal =
  data.reduce((sum, row) => sum + (Number(row.Total) || 0), 0) || 0;


const grandTotalRow = [
  "", // placeholder for Expense Head
  ...monthCols.map(() => ""), 
  grandTotal.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }),
];
bodyRows.push(grandTotalRow);

autoTable(doc, {
  head: [headRow],
  body: bodyRows,
  startY: 25,
  theme: "grid",
  margin: { left: 5, right: 3 },
  styles: {
    fontSize: 8,
    cellPadding: 1,
    textColor: [0, 0, 0],
    lineColor: [0, 0, 0],
    lineWidth: 0.2,
  },
  headStyles: {
    fillColor: [255, 255, 255],
    textColor: [0, 0, 0],
    fontStyle: "bold",
    halign: "center",
  },
  columnStyles: colStyles,
  didParseCell: (data) => {
    // If it's the Grand Total row
    if (data.row.index === bodyRows.length - 1) {
      data.cell.styles.fontStyle = "bold";

      // Merge all columns into one centered cell
      if (data.column.index === 0) {
        data.cell.colSpan = monthCols.length + 1; // span all columns
        data.cell.text = [
          `Grand Total: ${grandTotal.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
        ];
        data.cell.styles.halign = "center";
      } else {
        data.cell.text = [""];
      }
    }
  },
});

  // Open PDF in new tab
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};


  return (
    <>
      <div className="flex  bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <Header />
          <div className="flex justify-center mt-10">
            <div className="meterTableMain flex flex-col justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Monthly Expense Report</h1>
              </div>
              <div className="flex flex-col h-40 content-center items-center justify-items-center justify-evenly">
                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-white" htmlFor="startDate">
                      Starting Date:
                    </label>
                    <input
                      type="date"
                      name="startingDate"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                    <label className="text-white ml-5" htmlFor="endDate">
                      Ending Date:
                    </label>
                    <input
                      type="date"
                      name="enteredOn"
                      className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                      onChange={onChangeText}
                    />
                  </div>
                </div>
                <div className="flex items-center">
                  <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                  <button
                    onClick={clearFields}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpRprt;
